import store from "@/store";
import i18n from "@/i18n";
import { loadScript } from "@/utils/loadScript.js";
import { Api } from "@/services/api.js";

const api = new Api();

function updateLanguage(setting, lang) {
  if (lang) {
    let language = lang == "en" ? lang : "zh-TW";
    localStorage.setItem("lang", language);
    setting.locale = language;
  } else {
    setting.locale = localStorage.getItem("lang");
  }
}

async function getUserInfo(userId) {
  const apiHost = process.env.VUE_APP_API_HOST;
  const merchantId = process.env.VUE_APP_MERCHANT_ID;
  const config = {
    method: "get",
    url: `${apiHost}/identities/v1/merchants/${merchantId}/members/${userId}`,
    headers: {},
  };

  const res = await api.$http(config);
  return api.useData(res);
}

async function sdk() {
  try {
    await loadScript(process.env.VUE_APP_SSO_SDK);

    store.commit("updateQcssoSdk", qcsso);

    let qcssoConfig = { appId: process.env.VUE_APP_ID };
    
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const referralCode = urlParams.get('referralCode');
    if (referralCode) qcssoConfig.params = { referralCode };
    
    await store.state.qcssoSdk.init(qcssoConfig);

    if (! store.state.qcssoSdk.isLoggedIn()) {
      store.commit("updateIsLoggedIn", false);
      store.commit("updateUser", {});
      store.commit("updateUserInfo", {});
    } else {
      store.commit("updateIsLoggedIn", true);

      const user = await store.state.qcssoSdk.getProfile();
      store.commit("updateUser", user);

      const profile = await getUserInfo(user.userId);
      store.commit("updateUserInfo", api.useData(profile));

      // Start: Flutter init logic.
      const args = {
        type: "login",
        payload: {
          token: localStorage.getItem(`QCSSO:${sessionStorage.getItem('QCSSO:sessionAppId')}:accessToken`),
          user_id: user.userId,
          uuid: user.userId,
          member_id: profile.memberId
        }
      };
      window.Yunlin?.postMessage(JSON.stringify(args));
      window.flutter_inappwebview?.callHandler('Yunlin', JSON.stringify(args));
      
      console.log("JS Interface", args);
      // End: Flutter init logic.
    }

    return true;
  } catch (err) {
    console.error(err);
  }
}

async function auth(router) {
  // Init qcsso sdk.
  await sdk();

  router.beforeEach((to, from, next) => {
    store.commit("updateCurrentPath", to.path);
    updateLanguage(i18n, to.query.lang);

    // Check session live?
    // If not reset store state, ui will show non-login mode.
    if (! store.state.qcssoSdk.isLoggedIn())
    {
      login();
      return;
    }

    if (to.path == "/") return next("/home");
    next();
  });
}

export function login() {
  try {
    store.state.qcssoSdk.login({
      redirectUrl: `${process.env.VUE_APP_HOST}${process.env.BASE_URL}`,
    });
  } catch (err) {
    console.error(err);
  }
}

export async function logout() {
  try {
    await store.state.qcssoSdk.logout({
      logoutRedirectUri: `${process.env.VUE_APP_HOST}${process.env.BASE_URL}`,
    });
  } catch (err) {
    console.error(err);
  }
}

export default auth;
